const state = {
    message: null,
    theme: 'info'
};

const actions = {
    showToast({commit, dispatch}, {message, theme = 'info'}) {
        commit('SET_MESSAGE', {message, theme})
    }
};

const mutations = {
    SET_MESSAGE(state, {message, theme}) {
        state.message = message;
        state.theme = theme;
    }
};

export default {
    state,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/toast.js